import { lazy } from "react";
import { Route, Switch } from "react-router-dom";
import BulkUploadResultsStatusGroupingPage from "@faire/prototype-playground/workspace/ad/bulk-upload-status-grouping";
import PopUpShopNameGeneratorPage from "../../workspace/ad/pop-up-shop-name-generator";
import ProductTemplatesForBrandsPage from "../../workspace/ad/product-templates-for-brands";

const BulkEditorPlaceholderPage = lazy(() =>
  import("../../pages/new-cc-homepage-banner/BulkEditorPlaceholderPage").then(
    (m) => ({ default: m.default })
  )
);
const BulkUploadExportPage = lazy(() => import("../../pages/BulkUploadExport"));
const CcReviewProductsPage = lazy(() =>
  import("../../pages/new-cc-homepage-banner/ReviewProductsPage").then((m) => ({
    default: m.default,
  }))
);
const SlateTableTestPage = lazy(
  () => import("../../pages/faire/SlateTableTestPage")
);
const CCLoadingModalSequencePage = lazy(
  () => import("../../pages/CCLoadingModalSequence")
);
const FalseOutOfStockNudgePage = lazy(
  () => import("../../pages/faire/FalseOutOfStockNudgePage")
);
const InventoryInsightsPage = lazy(
  () => import("../../pages/InventoryInsightsPage")
);
const InventoryInsightsInProductM1Page = lazy(
  () => import("../../pages/inventory-insights-in-product-m1")
);
const OrdersPage = lazy(() => import("../../pages/OrdersPage"));
const ProductsTable2Page = lazy(
  () => import("../../pages/faire/ProductsTable2Page")
);
const ReadyToListPage = lazy(() => import("../../pages/ReadyToList"));
const TableBuilderPage = lazy(
  () => import("../../pages/faire/TableBuilderPage")
);
const NewCcHomepageBannerPage = lazy(
  () => import("../../pages/new-cc-homepage-banner")
);
const CCProductsPage = lazy(() =>
  import("../../pages/new-cc-homepage-banner/CCProductsPage").then((m) => ({
    default: m.default,
  }))
);
const CCSingleProductEditorPage = lazy(() =>
  import("../../pages/new-cc-homepage-banner/CCSingleProductEditorPage").then(
    (m) => ({ default: m.default })
  )
);
const CCBulkUploadPage = lazy(() =>
  import("../../pages/new-cc-homepage-banner/CCBulkUploadPage").then((m) => ({
    default: m.default,
  }))
);
const BrandPortalFeedOrientedHomepageConceptsPage = lazy(
  () => import("../../pages/BrandPortalFeedOrientedHomepageConcepts")
);
const ProductsPageTemplate = lazy(
  () => import("../../pages/ProductsPageTemplate")
);
const RestingTypeaheadSuggestionsPage = lazy(
  () => import("../../pages/RestingTypeaheadSuggestionsPage")
);

export function AustinDickRoutes() {
  return (
    <Switch>
      <Route path="/ad/faire/products-table-2" component={ProductsTable2Page} />
      <Route
        path="/ad/faire/false-out-of-stock-nudge"
        component={FalseOutOfStockNudgePage}
      />
      <Route path="/ad/table-builder" component={TableBuilderPage} />
      <Route path="/ad/orders" component={OrdersPage} />
      <Route
        path="/ad/inventory-insights-in-product-m1"
        component={InventoryInsightsInProductM1Page}
      />
      <Route path="/ad/inventory-insights" component={InventoryInsightsPage} />
      <Route path="/ad/bulk-upload-export" component={BulkUploadExportPage} />
      <Route
        path="/ad/cc-loading-modal-sequence"
        component={CCLoadingModalSequencePage}
      />
      <Route path="/ad/ready-to-list" component={ReadyToListPage} />
      <Route path="/ad/slate-table-test" component={SlateTableTestPage} />
      <Route path="/ad/cc-review-products" component={CcReviewProductsPage} />
      <Route path="/ad/cc-bulk-editor" component={BulkEditorPlaceholderPage} />
      <Route
        path="/ad/new-cc-homepage-banner/products"
        component={CCProductsPage}
      />
      <Route
        path="/ad/new-cc-homepage-banner/spe"
        component={CCSingleProductEditorPage}
      />
      <Route
        path="/ad/new-cc-homepage-banner/bulk-upload"
        component={CCBulkUploadPage}
      />
      <Route
        path="/ad/new-cc-homepage-banner"
        component={NewCcHomepageBannerPage}
      />
      <Route
        path="/ad/brand-portal-feed-homepage-concepts"
        component={BrandPortalFeedOrientedHomepageConceptsPage}
      />
      <Route path="/ad/bulk-upload-status-grouping" component={BulkUploadResultsStatusGroupingPage} />
      <Route
        path="/ad/pop-up-shop-name-generator"
        component={PopUpShopNameGeneratorPage}
      />
      <Route
        path="/ad/product-templates-for-brands"
        component={ProductTemplatesForBrandsPage}
      />
      <Route
        path="/ad/products-page-template"
        component={ProductsPageTemplate}
      />
      <Route
        path="/ad/resting-typeahead-suggestions"
        component={RestingTypeaheadSuggestionsPage}
      />
    </Switch>
  );
}

export const slug = "ad";
